<template>
  <footer>
    <div style="margin: auto">
      <img alt="logo certisign" src="../../../static/img/logo_certisign_24_white.png"/>
    </div>
  </footer>

</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
footer {
  padding: 0 141px;
  align-items: center;
  gap: 4rem;
  display: flex;
  color: var(--color-ffffff);
  bottom: 0;
  background: var(--dark-blue) 0 0 no-repeat padding-box;
  width: 100%;
  height: 96px;
}

footer > div > img {
  width: 150px;
  height: auto;
}

footer > span {
  font: var(--font-style-normal) normal var(--font-weight-medium) 12px/20px var(--font-family-poppins);
  letter-spacing: var(--character-spacing-0);
  color: var(--color-ffffff);
  text-align: left;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// Footer.vue?01e0242d